import { csrfRequest } from './helpers/request'

export const finishWebAuthnRegistration = data =>
  csrfRequest({
    url: '/users/mfa/webauthn/register',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(response => {
    if (response.status === 204) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(new Error(response.status))
    }
  })
